import {useState} from 'react'
import {threeDots,microPhone,mediaFiles,arrowUp} from "@img";

export default function HelpSearch() {
    const [query, setQuery] = useState('')

    return (
        <div className="relative white-global-section mb-8 max-md:mb-4 max-md:p-0 max-md:shadow-none max-md:rounded-none">
            {/* The ask-anything search isn't live yet — transparent overlay over
                just this Help Center section. */}
            <div className="absolute inset-0 z-20 bg-white/60 backdrop-blur-[2px] rounded-3xl max-md:rounded-2xl flex items-center justify-center">
                <h3 className="font-bold text-2xl mb-0! max-md:text-lg!">Coming Soon</h3>
            </div>
            <h5 className="font-bold mb-5! max-md:mb-3! max-md:text-base!">Help Center</h5>
            <div className="flex items-center gap-4 max-md:bg-white max-md:p-3 max-md:shadow-[1px_7px_22px_0px_rgba(32,32,32,0.11)] max-md:rounded-[20px]">
                <div className="flex-1 min-w-0 flex items-center gap-4 border border-(--bg-dark-grey) rounded-4xl px-6 py-10 max-md:flex-col max-md:items-stretch max-md:gap-2 max-md:rounded-2xl max-md:py-3 max-md:px-3">
                    <div className="flex items-center gap-4 flex-1 min-w-0 max-md:gap-2">
                        <span className="text-(--text-primary) font-bold text-xl leading-none tracking-widest shrink-0"><img alt="dots" src={threeDots}/></span>
                        <input
                            name="question"
                            type="text"
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            placeholder="Don't think too much, ask me"
                            className="flex-1 min-w-0 outline-none bg-transparent font-bold text-xl text-(--text-primary) placeholder:text-(--text-primary) max-md:font-normal max-md:text-xs max-md:text-(--text-secondary) max-md:placeholder:text-(--text-secondary)"
                        />
                    </div>
                    <div className="flex items-center gap-3 max-md:justify-end">
                        <button><img alt="microphone" src={microPhone}/></button>
                        <button><img alt="media" src={mediaFiles}/></button>
                    </div>
                </div>
                <button className="cursor-pointer w-12 h-12 rounded-full bg-(--accent-green-light) flex items-center justify-center shrink-0 max-md:w-10 max-md:h-10">
                    <img alt="submit" src={arrowUp}/>
                </button>
            </div>
        </div>
    )
}
